import React from 'react';

import {Button, FlatButton} from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';

import {filtersFooter} from './filters-footer.module.styl';

type Props = {
    onClear: () => void,
    onApply: () => void,
    disableApply?: boolean,
    disableClear?: boolean,
};

export const FiltersFooter = ({onApply, onClear, disableApply, disableClear}: Props) => {
    return (
        <Group gap="xl" alignItems="center" className={filtersFooter}>
            <Button
                variant="Type.PRIMARY"
                onClick={onApply}
                disabled={disableApply}>
                Apply Filters
            </Button>
            <FlatButton
                onClick={onClear}
                disabled={disableClear}>
                <b>Reset</b>
            </FlatButton>
        </Group>
    );
};
